const appInfo = {
    title: 'Redlore'
};
export default appInfo;

